// extracted by mini-css-extract-plugin
export default {"wrapper":"ItemDetails_wrapper__ycVQE","items-container":"ItemDetails_items-container__z0W4L"};